<div class="basic-popup-grid-container">
  <div class="dialog-header">
    <div class="header-left">
      <span class="dialog-title">{{ heading }}</span>
      <span class="dialog-count">({{ rowCount }})</span>
    </div>

    <div class="header-center">
      <div class="search-wrapper">
        <input
          class="search-input"
          type="search"
          placeholder="Type to Search"
          [ngModel]="searchText"
          (ngModelChange)="onSearchChanged($event)"
        />
      </div>
    </div>

    <div class="header-right">
      <!-- <span class="page-size-label">Page Size</span>
      <input
        class="page-size-input"
        type="number"
        min="1"
        [(ngModel)]="pendingPageSize"
        (keyup.enter)="applyPageSize()"
      />
      <button class="page-size-go" type="button" (click)="applyPageSize()">Go</button> -->

      <div class="header-icons">
        <mat-icon
          class="action-icon"
          svgIcon="dotmenu_circle"
          [matMenuTriggerFor]="exportMenu">
        </mat-icon>

        <mat-menu #exportMenu="matMenu" class="scraii-bgrid-list-export-menu">
          <button mat-menu-item (click)="exportExcel()">
            <mat-icon [svgIcon]="'xls'"></mat-icon> Export to Excel</button>
        </mat-menu>

        <!-- Dialog close. Inline SVG so we don't depend on a registered
             `close` entry in IconService. Reuses the existing .close-btn
             styles (transparent button + hover background + currentColor SVG). -->
        <button type="button" class="close-btn" aria-label="Close" (click)="close()">
          <svg width="20" height="20" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

      </div>
    </div>
  </div>

  <!-- popupHost is the popupParent for ag-grid. Right-click context menu
       and per-column ⋮ menu render INSIDE this div (a descendant of :host)
       so the component-local `:host ::ng-deep *` rules can reach them.
       Without popupParent, ag-grid would attach popups to its own grid
       container — still inside :host, but with overflow:hidden chrome
       around it that can clip the menu. Pinning to the dialog body gives
       menus the full body bounds to expand into. -->
  <div class="dialog-body" #popupHost>
    <div class="loader-overlay" *ngIf="isLoading">
      <app-progress-indefinite></app-progress-indefinite>
    </div>

    <div class="state-message" *ngIf="!isLoading && errorMessage">
      {{ errorMessage }}
    </div>

    <div class="state-message" *ngIf="!isLoading && !errorMessage && rowData.length === 0">
      No data available.
    </div>

    <ag-grid-angular
      *ngIf="!isLoading && !errorMessage && rowData.length > 0"
      class="ag-theme-balham basic-popup-grid"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [animateRows]="true"
      [pagination]="true"
      [paginationPageSize]="paginationPageSize"
      [rowHeight]="rowHeight"
      [popupParent]="popupHost"
      [isExternalFilterPresent]="isExternalFilterPresent"
      [doesExternalFilterPass]="doesExternalFilterPass"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>
